import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  // ToggleButtonReuse,
  ToggleButtonReuseTwo,
  ToggleButtonWithYesNo,
} from "../../../AllButton/ToggleButtonReuse";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import store from "../../../../../../../store/store";
import { UPDATE_SUBSCRIPTION_TYPE } from "../../../../../../../store/types";

const MultiServiceOffersManagement = (props) => {
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === "view"
      ? true
      : false
  );
  let history = useHistory();
  const [state, setState] = useState({
    casualDiningOfflineOffers: false,
    casualDiningOnlineOffers: false,
    casualDiningOnlineOffersTotalPercentage: false,
    casualDiningOnlineOffersTotalAmount: false,
  });

  const casualDiningOfflineOffersHandler = (e) => {
    setState({
      ...state,
      casualDiningOfflineOffers: !state.casualDiningOfflineOffers,
    });
  };

  const casualDiningOnlineOffersHandler = (e) => {
    setState({
      ...state,
      casualDiningOnlineOffers: !state.casualDiningOnlineOffers,
    });
  };

  const casualDiningOnlineOffersTotalPercentageHandler = (e) => {
    setState({
      ...state,
      casualDiningOnlineOffersTotalPercentage:
        !state.casualDiningOnlineOffersTotalPercentage,
      casualDiningOnlineOffers: true,
    });
  };

  const casualDiningOnlineOffersTotalAmountHandler = (e) => {
    setState({
      ...state,
      casualDiningOnlineOffersTotalAmount:
        !state.casualDiningOnlineOffersTotalAmount,
      casualDiningOnlineOffers: true,
    });
  };

  useEffect(() => {
    setState({
      casualDiningOfflineOffers:
        props.subscriptionData && props.subscriptionData.offline_offer,
      casualDiningOnlineOffers:
        props.subscriptionData && props.subscriptionData.online_offer.value,
      casualDiningOnlineOffersTotalPercentage:
        props.subscriptionData &&
        props.subscriptionData.online_offer.percentage_total_order_value,
      casualDiningOnlineOffersTotalAmount:
        props.subscriptionData &&
        props.subscriptionData.online_offer.amount_toward_order_value,
    });
  }, [props.subscriptionData]);

  const onCasualOnlineOffersSubmitClick = (e) => {
    let values = {
      offline_offer: state.casualDiningOfflineOffers,
      online_offer: {
        value: state.casualDiningOnlineOffers,
        percentage_total_order_value:
          state.casualDiningOnlineOffersTotalPercentage,
        amount_toward_order_value: state.casualDiningOnlineOffersTotalAmount,
      },
      value:
        state.casualDiningOfflineOffers || state.casualDiningOnlineOffers
          ? true
          : false,
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    formData.multi_service_business_status.offer_management = values;
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Offers subscription added successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: true,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    
    if (props.history.location.pathname.includes("admin")) {
      history.push("/admin-edit-add-subscription");
    } else {
      history.push("/subscription");
    }
  };

  const backButtonHandler = (e) => {
    e.preventDefault();
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: true,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    
    if (props.history.location.pathname.includes("admin")) {
      history.push("/admin-edit-add-subscription");
    } else {
      history.push("/subscription");
    }
  };

  // if (props.auth.loader === true) {
  //   return (
  //     <React.Fragment>
  //       <AmealioLoader />
  //     </React.Fragment>
  //   );
  // } else {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
          >
            <Media query="(min-width: 992px)">
              <div className="col-12">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  workWithLinkORClick={true}
                  notDisplaProgressBar={true}
                  backButtonClicked={(e) => backButtonHandler(e)}
                />
              </div>
            </Media>

            <Media query="(max-width: 991px)">
              <MobileTopHeader
                link={false}
                onClick={(e) => backButtonHandler(e)}
              />
            </Media>

            <div className="onboarding_process_screen-button-map inside-subscription-offers-section">
              <TopTextReusableComponent headingText="Offers Management" />
              <div className="col-12 p-0">
                <div className="f18-700 py-4">Activate Offer Types</div>
                <ToggleButtonReuseTwo
                  mainText="Offline Offers"
                  paragraphText="(Note: these offers can be only be used in your business location offline)"
                  checkedBox={state.casualDiningOfflineOffers}
                  onChange={casualDiningOfflineOffersHandler}
                  disabled={disabled}
                />
                <hr className="mt-5 mb-5" />
                <ToggleButtonReuseTwo
                  mainText="Online Offers"
                  paragraphText="(Note: these offers can be only be used on application platform for Ordering and Booking)"
                  checkedBox={state.casualDiningOnlineOffers}
                  disabled={disabled}
                  onChange={casualDiningOnlineOffersHandler}
                />
                <div className="col-12 online-offline-offer-bottom-text">
                  <div className="my-3 f12-400 opacity5">
                    Following Options are available at this time, we keep adding
                    new ways frequently, you can come back to enable them
                    periodically and maintain information at time of creation of
                    online offers/deals/coupons On the platform.
                  </div>
                  <div className="f11-400 opacity5">
                    You can maintain specifics at the time of Offer creation for
                    applicable services
                  </div>
                  <div className="mt-3 f14-700">
                    Description of available options :
                  </div>
                  <div className="row">
                    <div className="col-8">
                      <div className="f13-500 mt-3">
                        Percent of Total Order Value
                      </div>
                    </div>
                    <div className="col-4 mt-3">
                      <ToggleButtonWithYesNo
                        activeClass={
                          state.casualDiningOnlineOffersTotalPercentage
                        }
                        checkedBox={
                          state.casualDiningOnlineOffersTotalPercentage
                        }
                        onChange={
                          casualDiningOnlineOffersTotalPercentageHandler
                        }
                        disabled={disabled}
                      />
                    </div>
                    <div className="col-8">
                      <div className="f13-500 mt-3">
                        Amount towards Total Order Value
                      </div>
                    </div>
                    <div className="col-4 mt-3">
                      <ToggleButtonWithYesNo
                        activeClass={state.casualDiningOnlineOffersTotalAmount}
                        checkedBox={state.casualDiningOnlineOffersTotalAmount}
                        onChange={casualDiningOnlineOffersTotalAmountHandler}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="onboarding-map-setup-screen-autodetect-button ">
                <ReusableOnboardingButton
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  buttonType="button"
                  onClick={(e) => backButtonHandler(e)}
                />
                {!disabled && (
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Done"
                    buttonType="button"
                    onClick={onCasualOnlineOffersSubmitClick}
                    disabled={disabled}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              // displayBarButton={true}
              displayHamburger={true}
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-02.svg")}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
  // }
};

MultiServiceOffersManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth,

  subscription: ownProps?.location?.pathname?.includes("admin")
    ? state?.superAdminOnboarding?.onboard_subscription_details
    : state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData: ownProps?.location?.pathname?.includes("admin")
    ? state?.superAdminOnboarding?.onboard_subscription_details
        .multi_service_business_status.offer_management
    : state.onboarding &&
      state.onboarding.onboard_subscription_details &&
      state.onboarding.onboard_subscription_details
        .multi_service_business_status &&
      state.onboarding.onboard_subscription_details
        .multi_service_business_status.offer_management,
  allSubscriptionsData: ownProps?.location?.pathname?.includes("admin")
    ? state?.superAdminOnboarding?.onboard_subscription_details
    : state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(MultiServiceOffersManagement));
